const state = {
    showVerticalMenu: false,

    counters: {},
    showCounters: false,
    reportingCountersAreSet: false,

    menuRoutes: '',

    filterOptions: {},

    filters: {
        accountingFirmCompany: 0,
        accountingFirmOffice: 0,
        legalForm: 0,
        accountingFirmUser: 0,
        endOfExercise: 0,
        role: 0,
        clientGroup: 0,
        balanceStep: 0,
        legalStep: 0,
        before: null,
    },

    search: null,

    viewAllClients: false,
}

const mutations = {
    SET_SEARCH(state, search) {
        state.search = search
    },

    RESET_SEARCH(state) {
        state.search = null
    },

    SET_VIEW_ALL_CLIENTS(state, viewAllClients) {
        state.viewAllClients = viewAllClients
    },

    SET_REPORTING_COUNTERS(state) {
        state.reportingCountersAreSet = true
    },
    RESET_REPORTING_COUNTERS(state) {
        state.reportingCountersAreSet = false
    },

    SET_COUNTER(state, [data, type]) {
        state.counters[type] = data
    },

    SHOW_COUNTERS(state) {
        state.showCounters = true
    },
    HIDE_COUNTERS(state) {
        state.showCounters = false
    },

    SET_MENU_ROUTES(state, menuRoutes) {
        state.menuRoutes = menuRoutes
    },

    SET_FILTERS(state, filters) {
        state.filters = filters
    },

    SET_LEGAL_FORM_FILTER(state, option) {
        state.filters.legalForm = option
    },

    SET_ACCOUNTING_FIRM_COMPANY_OPTION(state, option) {
        state.filters.accountingFirmCompany = option
    },

    SET_ACCOUNTING_FIRM_OFFICE_OPTION(state, option) {
        state.filters.accountingFirmOffice = option
    },

    SET_ACCOUNTING_FIRM_USER_OPTION(state, option) {
        state.filters.accountingFirmUser = option
    },

    SET_CLIENT_GROUP_OPTION(state, option) {
        state.filters.clientGroup = option
    },

    SET_BALANCE_STEP_OPTION(state, option) {
        state.filters.balanceStep = option
    },

    SET_LEGAL_STEP_OPTION(state, option) {
        state.filters.legalStep = option
    },

    SET_END_OF_EXERCISE_OPTION(state, option) {
        state.filters.endOfExercise = option
    },

    SET_ROLE_OPTION(state, option) {
        state.filters.role = option
    },

    SHOW_VERTICAL_MENU(state) {
        state.showVerticalMenu = true
    },
    HIDE_VERTICAL_MENU(state) {
        state.showVerticalMenu = false
    },

    SET_BEFORE_FILTER(state, value) {
        state.beforeFilter = value
    },

    RESET_BEFORE_FILTER(state) {
        state.beforeFilter = null
    },
}

const actions = {
    async getCounter({commit}, type) {
        try {
            const response = await axios.get(`/reporting/counter/${type}`)
            commit('SET_COUNTER', [response.data, type])
            if (type === 'all') {
                commit('SET_REPORTING_COUNTERS')
            }
        } catch (error) {
            console.log(`counter ${type}not loaded`)
        }
    },

    async getAllCounters({commit}) {
        try {
            const response = await axios.get('/counters')
            commit('SET_COUNTER', [response.data.tvs, 'tvs'])
            commit('SET_COUNTER', [response.data.cac, 'cac'])
            commit('SET_COUNTER', [response.data.tss, 'tss'])
            commit('SET_COUNTER', [response.data.das, 'das'])
            commit('SET_COUNTER', [response.data.dsi, 'dsi'])
            commit('SET_COUNTER', [response.data.cfe, 'cfe'])
            commit('SET_COUNTER', [response.data.cva, 'cva'])
            commit('SET_COUNTER', [response.data.vat, 'vat'])
            commit('SET_COUNTER', [response.data.ten, 'ten'])
            commit('SET_COUNTER', [response.data.sit, 'sit'])
            commit('SET_COUNTER', [response.data.iss, 'iss'])
            commit('SET_COUNTER', [response.data.bil, 'bil'])
            commit('SET_COUNTER', [response.data.oth, 'oth'])
            commit('SET_COUNTER', [response.data.all, 'all'])

            commit('SET_REPORTING_COUNTERS')
        } catch (error) {
            console.log(`counter ${type}not loaded`)
        }
    },

    async refreshCounters({dispatch}) {
        await dispatch('getAllCounters')
    },

    async getRoutes({commit}) {
        try {
            const response = await axios.get('/reporting/routes')
            commit('SET_MENU_ROUTES', response.data)
            commit('SET_VIEW_ALL_CLIENTS', response.data.viewAllClients)
        } catch (error) {
            // console.log(error)
            console.log('menuRoutes not loaded')
        }
    },

    async getFilters({commit}) {
        console.log('getFilters')
        try {
            const response = await axios.get('/filters')
            commit('SET_FILTERS', response.data)
            commit('SET_VIEW_ALL_CLIENTS', response.data.viewAllClients)
        } catch (error) {
            console.log('filters not loaded')
        }
    },

    async setLegalFormFilter({commit}, option) {
        try {
            await axios.post(`/filters/legalForms/${option}/set`)
            commit('SET_LEGAL_FORM_FILTER', option)
        } catch (error) {
            console.log('legalFormFilter not set')
        }
    },

    async setAccountingFirmCompanyFilter({commit}, option) {
        try {
            await axios.post(`/filters/accountingFirmCompanies/${option}/set`)
            commit('SET_ACCOUNTING_FIRM_COMPANY_OPTION', option)
        } catch (error) {
            console.log('accountingFirmCompany not set')
        }
    },

    async setAccountingFirmOfficeFilter({commit}, option) {
        try {
            await axios.post(`/filters/accountingFirmOffices/${option}/set`)
            commit('SET_ACCOUNTING_FIRM_OFFICE_OPTION', option)
        } catch (error) {
            console.log('accountingFirmOffice not set')
        }
    },

    async setRoleFilter({commit}, option) {
        try {
            await axios.post(`/filters/roles/${option}/set`)
            commit('SET_ROLE_OPTION', option)
        } catch (error) {
            console.log('role not set')
        }
    },

    async setEndOfExerciseFilter({commit}, option) {
        try {
            await axios.post(`/filters/end-of-exercise/${option}/set`)
            commit('SET_END_OF_EXERCISE_OPTION', option)
        } catch (error) {
            console.log('end of exercise not set')
        }
    },

    async setAccountingFirmUserFilter({commit, dispatch}, option) {
        try {
            await axios.post(`/filters/accountingFirmUsers/${option}/set`)
            commit('SET_ACCOUNTING_FIRM_USER_OPTION', option)
            if (option === 0) {
                commit('SET_ACCOUNTING_FIRM_USER_OPTION', 0)
            }
        } catch (error) {
            console.log('accountingFirmUser not set')
        }
    },

    async setClientGroupFilter({commit, dispatch}, option) {
        try {
            await axios.post(`/filters/clientGroups/${option}/set`)
            commit('SET_CLIENT_GROUP_OPTION', option)
            if (option === 0) {
                commit('SET_CLIENT_GROUP_OPTION', 0)
            }
        } catch (error) {
            console.log('clientGroup not set')
        }
    },

    async setBalanceStepFilter({commit, dispatch}, options) {
        try {
            await axios.post(`/filters/balanceSteps/set`, {'options': options})
            commit('SET_BALANCE_STEP_OPTION', options)
        } catch (error) {
            console.log('balanceStep not set')
        }
    },

    async setLegalStepFilter({commit, dispatch}, options) {
        try {
            await axios.post(`/filters/legalSteps/set`, {'options': options})
            commit('SET_LEGAL_STEP_OPTION', options)
        } catch (error) {
            console.log('legalStep not set')
        }
    },

    async setBeforeFilter({commit}, value) {
        try {
            await axios.post(`/filters/before/${value}/set`)
            console.log('SET_BEFORE_FILTER', value)
            commit('SET_BEFORE_FILTER', value)
        } catch (error) {
            console.log('before filter not set')
        }
    },

    async resetBeforeFilter({commit}) {
        try {
            await axios.post('/filters/before/reset')
            console.log('RESET_BEFORE_FILTER')
            commit('RESET_BEFORE_FILTER')
        } catch (error) {
            console.log('before filter is reset')
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
